import { lookupsJson, validZipCodeRanges } from '@ourbranch/lookups';

// 5-digit ZIP or ZIP+4 (hyphen optional): the same format the auto rater accepts. It refuses to rate
// anything else, e.g. a 6-digit typo.
export const ZIP_CODE_REGEX = /^\d{5}(-?\d{4})?$/;

export const checkZipCodeRange = (zip, state) => {
  const zipCodeRanges = validZipCodeRanges[state] || [];
  const numericZip = parseInt(zip, 10);
  return zipCodeRanges.some((zipRange) => {
    if (typeof zipRange === 'number') {
      return zipRange === numericZip;
    }
    return numericZip >= zipRange[0] && numericZip <= zipRange[1];
  });
};

export const getStateFullName = (state) => {
  const name = lookupsJson.usStates.find((stateName) => stateName.id === state);
  return name?.value;
};
